module.exports = __webpack_public_path__ + "static/media/Bicocca - Black_White.ea1336a2.jpg";